import { render } from "./WizardItem.vue?vue&type=template&id=93d0b952&scoped=true"
import script from "./WizardItem.vue?vue&type=script&lang=js"
export * from "./WizardItem.vue?vue&type=script&lang=js"

import "./WizardItem.vue?vue&type=style&index=0&id=93d0b952&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-93d0b952"]])

export default __exports__
import QSpinner from 'quasar/src/components/spinner/QSpinner.js';
import QIcon from 'quasar/src/components/icon/QIcon.js';
import QBtn from 'quasar/src/components/btn/QBtn.js';
import QTooltip from 'quasar/src/components/tooltip/QTooltip.js';
import qInstall from "../../../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(script, 'components', {QSpinner,QIcon,QBtn,QTooltip});
